class SetTargetBlank {
  constructor(config = {}) {
    const {
      targetBlanks,
    } = config;

    this.targetBlank = document.querySelectorAll(targetBlanks);
    this.targetBlankArray = Array.prototype.slice.call(this.targetBlank);

    if (this.targetBlank.length !== 0) {
      this.bindEvents();
    }
  }

  bindEvents() {
    this.targetBlankArray.forEach((item)=>{
      this.setTargetBlanks(item);
    });
  }

  setTargetBlanks(item) {
    let newItem = item.querySelector('a');
    newItem.setAttribute('target', '_blank');
  }
}

export default SetTargetBlank;
